export default __webpack_public_path__ + "static/media/OnlineBadge.8fba3f83.svg";